import { Action, actionCreatorFactory } from 'typescript-fsa'

import { MediaItem } from '../api/types'

const actionCreator = actionCreatorFactory('MediaItem')

export interface LoadMediaItemParams {
	id: number
	version: number
	language: string
}
export type LoadMediaItemAction = Action<LoadMediaItemParams>
export const loadMediaItem = actionCreator<LoadMediaItemParams>('LOAD_MEDIA_ITEM')

export interface LoadedMediaItemResult {
	id: number
	version: number
	language: string
	mediaItem: MediaItem
}
export type LoadedMediaItemResultAction = Action<LoadedMediaItemResult>

export const loadedMediaItemFromDisk = actionCreator<LoadedMediaItemResult>('LOADED_MEDIA_ITEM_FROM_DISK')

export const removeMediaItemFromDisk = actionCreator<LoadMediaItemParams>('REMOVE_MEDIA_ITEM_FROM_DISK')
